import React from 'react'
import {
  BrowseIcon,
  DiscussIcon,
  FoliosIcon,
  LearnIcon,
  ScreensIcon,
  TodayIcon,
} from 'src/components/framework/icons/sidebar'

import { SidebarItem } from './sidebar-item'
import * as styles from './sidebar.module.scss'

export const Sidebar: React.FC = () => (
  <nav className={styles.sidebar} aria-label="Primary navigation">
    <SidebarItem text="Today" link="/" icon={TodayIcon} />
    <SidebarItem text="Browse" link="/features/stockranks" icon={BrowseIcon} />
    <SidebarItem
      text="Screens"
      link="/features/stock-screener"
      icon={ScreensIcon}
    />
    <SidebarItem text="Folios" link="/features/portfolios" icon={FoliosIcon} />
    <SidebarItem text="Discuss" link="/discussion" icon={DiscussIcon} />
    <SidebarItem
      text="Learn"
      link="https://help.stockopedia.com"
      icon={LearnIcon}
    />
  </nav>
)
